// @core/api/endpoints/team/update_temporary_role_assignment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTemporaryRoleAssignmentRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update temporary role assignment
 * Updates an existing temporary role assignment with the provided data. Returns the updated resource.
 */
export async function UpdateTemporaryRoleAssignment(
  team_id: string,
  assignment_id: string,
  data: UpdateTemporaryRoleAssignmentRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/temporary-assignments/:assignment_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':assignment_id', encodeURIComponent(assignment_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
